// Debug script for logo-list slider
document.addEventListener('DOMContentLoaded', function() {
  
  const logoSliders = document.querySelectorAll('.hdt-logo-list');
  
  logoSliders.forEach((slider, index) => {
    
    // Check classes
    const classes = slider.className;
    
    // Check if it has the correct slide classes
    const hasLgSlides = classes.includes('lg:hdt-slides-');
    const hasMdSlides = classes.includes('md:hdt-slides-');
    const hasSlides = classes.includes('hdt-slides-');
    

    
    // Check container
    const container = slider.querySelector('.hdt-slider__container');
    if (container) {
     
    }
    // Check slides
    const slides = slider.querySelectorAll('.hdt-slider__slide');
    
    slides.forEach((slide, slideIndex) => {
      const slideStyle = getComputedStyle(slide);
    });
    
    // Check CSS variables
    const rootStyle = getComputedStyle(document.documentElement);
    const slideSize = rootStyle.getPropertyValue('--slide-size');
    
    // Force correct display if needed
    if (container) {
      container.style.display = 'flex';
      container.style.flexDirection = 'row';
    }
    
    slides.forEach((slide, slideIndex) => {
      slide.style.flex = '0 0 var(--slide-size)';
      slide.style.width = 'var(--slide-size)';
      slide.style.minWidth = 'var(--slide-size)';
    });
  });
});

// Re-run when sections are loaded
document.addEventListener('shopify:section:load', function(event) {
  // Re-run the same logic
  const logoSliders = event.target.querySelectorAll('.hdt-logo-list');
  logoSliders.forEach(slider => {
    const container = slider.querySelector('.hdt-slider__container');
    const slides = slider.querySelectorAll('.hdt-slider__slide');
    
    if (container) {
      container.style.display = 'flex';
      container.style.flexDirection = 'row';
    }
    
    slides.forEach(slide => {
      slide.style.flex = '0 0 var(--slide-size)';
      slide.style.width = 'var(--slide-size)';
      slide.style.minWidth = 'var(--slide-size)';
    });
  });
});
